var isRegExp = require('../internals/is-regexp');

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};



//////////////////
// WEBPACK FOOTER
// /home/buzius/projects/easyflow-docker/workspace/easyflow/node_modules/vue-tel-input/node_modules/core-js/internals/not-a-regexp.js
// module id = 105
// module chunks = 0